import { useCallback, useState } from 'react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import useFileHandler from 'src/hooks/useFileHandler';
import { ProfileImageBase } from './styles';
const Wrap = styled.label`
  ${({
  theme
}) => ProfileImageBase(theme)}
  background-image: url('/images/icons/icFriendAddLarge.svg');
  position: relative;
`;
const borderDance = keyframes`
  0% {
    background-position: 0 0, 100% 100%, 0 100%, 100% 0;
  }
  100% {
    background-position: 100% 0, 0 100%, 0 0, 100% 100%;
  }
`;
const FileDropCursor = styled.div<{
  isFileDragging: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  background: ${({
  theme
}) => `linear-gradient(90deg, ${theme.color.surface7} 50%, transparent 50%), linear-gradient(90deg, ${theme.color.surface7} 50%, transparent 50%), linear-gradient(0deg, ${theme.color.surface7} 50%, transparent 50%), linear-gradient(0deg, ${theme.color.surface7} 50%, transparent 50%)`};
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size:
    15px 4px,
    15px 4px,
    4px 15px,
    4px 15px;
  animation: ${borderDance} 20s infinite linear;
  display: none;
  ${({
  isFileDragging
}) => isFileDragging && 'display: block'};
`;
interface Props {
  onImageSelected: (file: File) => void;
}
const Add = ({
  onImageSelected
}: Props) => {
  const [isFileDragging, setIsFileDragging] = useState(false);
  const handleChangeFile = useFileHandler(onImageSelected);
  const handleDragEnter = useCallback(() => {
    setIsFileDragging(true);
  }, []);
  const handleDragLeave = useCallback(() => {
    setIsFileDragging(false);
  }, []);
  const handleDragOver: React.DragEventHandler = useCallback(e => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
    setIsFileDragging(true);
  }, []);
  const handleDrop: React.DragEventHandler = useCallback(e => {
    setIsFileDragging(false);
    e.preventDefault();
    if (!e.dataTransfer.files?.length) {
      return;
    }
    const [file] = e.dataTransfer.files;
    onImageSelected(file);
  }, [onImageSelected]);
  return <Wrap htmlFor='profile-image-add-file' onDragEnter={handleDragEnter} data-sentry-element="Wrap" data-sentry-component="Add" data-sentry-source-file="Add.tsx">
      <input hidden type='file' id='profile-image-add-file' onChange={handleChangeFile} accept='image/*' />
      <FileDropCursor onDragEnter={handleDragEnter} onDragLeave={handleDragLeave} onDragOver={handleDragOver} onDrop={handleDrop} isFileDragging={isFileDragging} data-sentry-element="FileDropCursor" data-sentry-source-file="Add.tsx" />
    </Wrap>;
};
export default Add;